import React from "react";
import Slider from "react-slick";

export const TextSlider = (props) => {
  const sc = props.slice.primary;

  const items = props.slice.items;

  let space = sc.spacing;

  if (space === "Both large") {
    space = "gutter";
  } else if (space === "Both small") {
    space = "gutter sm";
  } else if (space === "Top large") {
    space = "gutter bot";
  } else if (space === "Top small") {
    space = "gutter bot sm";
  } else if (space === "Bottom large") {
    space = "gutter top";
  } else {
    space = "gutter top sm";
  }

  

  const settings = {
    
    slide: true,
    infinite: true,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 500,
    pauseOnHover: true,
    arrows: false,
    className: "text-slider",
  };

  return (
    <section className={"relative z-10 bg-" + sc.background + " " + space}>
      <div className="wrapper">
        
          <div className="w-auto m-auto md:w-11/12">
            
            <Slider {...settings}>
              {items.map((item, index) => {
                return (
                  <div className="" key={index}>
                    <div className="text-lg md:text-2xl text-teal mb-2 md:mb-4 font-bold">{item.label_text}</div>
                    <div className="text-lg md:text-2xl md:leading-normal">{item.main_text}</div>
                  </div>
                  );
                })}
            </Slider>
          </div>
      </div>
    </section>
  );
};
